import React, { Component } from 'react';
import { connect } from 'react-redux';
import {SubMenuLink} from "./SubMenuLink";

import _ from "i18n";

@connect((store) => {
  return {
    currentClient: store.auth.currentClient,
    loggedAs: store.auth.loggedAs,
    user: store.auth.user,
  }
})
export default class Statistics extends Component {

  render () {
    if(this.props.loggedAs === "ADMIN" || (this.props.user && (this.props.user.type === "ADMIN" )))
      return <SubMenuLink pathname="/admin/eventstats" title={_('stats')} icon="STATISTICS" subMenuDirection={this.props.subMenuDirection} currentClient={this.props.currentClient}/>;
  }
};



// WEBPACK FOOTER //
// ./app/components/menu/Statistics.js